var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStreamwaysLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "101px",
    height: "132px",
    viewBox: "0 0 101 132",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-24.6220613%",
    y1: "31.8108021%",
    x2: "59.2578578%",
    y2: "-29.3767257%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1E7FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85CDFF",
    offset: "18.2195594%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88B1FD",
    offset: "27.2625952%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F6BFC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "67.2568251%",
    y1: "62.8964884%",
    x2: "2.06429003%",
    y2: "14.7650661%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52D9D5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ADECE",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E3CE",
    offset: "40%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DE9D2",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0EFDA",
    offset: "67%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F8ED",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Guidelines-&-Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-143.000000, -2852.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-/-Symbol",
    transform: "translate(143.353513, 2852.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7929989,47.2891657 C75.7652135,41.124166 88.8075609,43.7263971 95.6502889,53.2463424 C102.493017,62.7662877 100.802921,75.9578762 91.7812239,83.4452837 L37.4008631,126.780649 C27.3636085,134.554806 13.0004633,133.128476 4.68818498,123.532121 C-2.75094441,114.533698 -0.931768663,102.254261 7.28700748,94.2953676 L65.7929989,47.2891657 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0873645,3.33658026 C24.1151499,-2.82841943 11.0728024,-0.226188344 4.23007448,9.29375694 C-2.61265348,18.8137022 -0.922557345,32.0052908 8.09913951,39.4926982 L62.4470149,82.6981222 C72.4786644,90.4514484 86.8182005,89.0260472 95.1272078,79.4495941 C102.566337,70.4186859 100.747161,58.1717349 92.5283853,50.212841 L92.5283853,50.212841 L34.0873645,3.33658026 Z",
    id: "Path",
    fill: "url(#linearGradient-2)",
    opacity: 0.835132417
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#674AD2",
    cx: 77.7800677,
    cy: 66.033173,
    r: 22.2199323
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamwaysLogo);
export default __webpack_public_path__ + "static/media/streamways-logo.95346544.svg";
export { ForwardRef as ReactComponent };